<template>
  <sPopover
    v-if="accessNotification"
    ref="notificationsPopover"
    placement="bottom-end"
    trigger="click"
    width="auto"
    @toggle="showMenu">
    <sBadge
      slot="reference"
      color="red"
      data-qa="nottification-bell-badge"
      dot
      offset-x="8"
      offset-y="8"
      :value="isNewNotification">
      <sButton
        data-qa="notifications-btn"
        icon="notifications"
        small
        type="border"/>
    </sBadge>
    <div class="notification-body">
      <div
        v-if="sortNotifications && sortNotifications.length"
        class="notification-body_cards">
        <NotificationCard
          v-for="(notification, notificationIndex) in sortNotifications"
          :key="`notification-${notificationIndex}`"
          :index="notificationIndex"
          :value="notification.message"
          @changeViewed="sendChangeView"
          @clickNotification="showNotification(notification)"/>
      </div>
      <div
        v-else
        class="pt-5 pb-4 text-center">
        {{ $t('Common.NoData') }}
      </div>
      <div
        class="notification-gotoAll text-uppercase">
        <sButton
          type="text"
          @click="gotoAllNotification">
          {{ $t('Notifications.GoToAllNotifications') }}
        </sButton>
      </div>
    </div>
    <sModal
      v-model="showModalNotification"
      :cancel-text="$t('Common.Close')"
      :closable="false"
      :content-class-name="'modal-notification'"
      :mask-closable="false">
      <div v-if="modalNotification">
        <div
          class="modal-notification__title width-100">
          <NotificationCard
            mode="modal"
            :value="modalNotification.message"
            @changeViewed="sendChangeView"
            @close="modalNotification = null"/>
        </div>
        <template
          v-if="modalNotification.innerChat">
          <InnerChatMessage
            style="max-height: 70vh;"
            :value="modalNotification.message"
            @clickTag="$_clickTag"/>
          <div v-if="modalNotification.message.attachments && modalNotification.message.attachments.length">
            {{ $t('Tenders.Files') }}: {{ modalNotification.message.attachments.length }}
          </div>
        </template>
        <div
          v-else
          v-dompurify-html="modalNotification.message.message"
          style="max-height: 70vh;"/>
      </div>
      <div
        key="footer"
        slot="footer">
        <sButton
          key="btn-close"
          class="width-100"
          type="green"
          @click="modalNotification = null">
          {{ $t('Common.Close') }}
        </sButton>
      </div>
    </sModal>
  </sPopover>
</template>
<script>
import NotificationCard from 'components/common/blocks/NotificationCard.vue'
import InnerChatMessage from 'components/common/blocks/inner-chat/InnerChatMessage.vue'

import { mapGetters, mapActions } from 'vuex'
import { functionRandom, innerChatMixin } from 'mixins'
import notifications from 'mixins/notifications'

export default {
  name: 'notificationsBell',
  mixins: [functionRandom, innerChatMixin, notifications],
  data() {
    return {
      modalNotification: null
    }
  },
  methods: {
    ...mapActions('notification', ['addNotifications', 'changeState' ]),
    sendChangeView(item) {
      this.$_changeViewedMessages([item])
    },
    /**
     * Сейчас с бека ключи приходят не в том формате в котором им отправляется с фронта
     * Очень надеюсь что скоро это удалим
     */
    getTagsInnerMessag(value) {
      const stringTags = value.message.tags || '[]'

      let tags = JSON.parse(stringTags)
      return tags.map(i => ({
        ...i,
        type: i.type || i.tagtype
      }))
    },
    getInnerChatMessage(notifyObject) {
      this.$_getCommentByType(notifyObject).then((result) => {
        notifyObject.message.message = result
      })
      return {
        message: notifyObject?.message?.message || '',
        tags: this.getTagsInnerMessag(notifyObject)
      }
    },
    showNotification(value) {
      if (!value.message.viewed) {
        this.sendChangeView(value.message)
      }

      this.$_getCommentByType(value).then((result) => {
        value.message.message = result
      })

      if (this.innerChatNotificationTypes.includes(value.message.eventType)) {
        value.innerChat = true
        value.message.tags = value.message.Tags ? JSON.parse(value.message.Tags) : []
        value.message.attachments = value.message.Attachments ? JSON.parse(value.message.Attachments) : []
      }
      this.modalNotification = value
    },
    gotoAllNotification() {
      this.$refs.notificationsPopover.showPopper = false
      this.$router.push({name: 'all-notification' })
    },
    showMenu() {
      if (!this.$refs.TooltipedText) { return }
      setTimeout(() => {
        this.$refs.TooltipedText.forEach((TooltipedText) => {
          TooltipedText.checkNeedShowTooltip()
        })
      }, 300)
    },
    addNewNotifications(notifications) {
      if (!notifications) {
        return
      }

      this.addNotifications(notifications).then((result) => {
        result.forEach((notification) => {
          this.$_getCommentByType(notification).then((result) => {
            notification.message.Comment = result
            const keyNotification = `${notification.entity.entityId}_${notification.entity.entityType}`

            if (this.$notice.instances.find(i => i.id === keyNotification)) {
              this.$notice.closeById(keyNotification)
            }
            const firstLine = `<div>${this.$t('Notifications.NotificationToTender', {
              tenderNumber: notification.entity.Number,
              tenderTitle: notification.entity.Title
            })}</div>`

            let message = '<div>' + notification.message.Comment + '</div>'

            //if (notification.message.messageType !== 'AddTenderBid') {
            message = firstLine + message
            //}

            if (this.innerChatNotificationTypes.includes(notification.message.messageType)) {
              const innerChatMessages = this.getInnerChatMessage(notification)

              message = firstLine + (innerChatMessages?.commentHtml || '')
            }
            const subscription = this.$_getCurrentSubscription({
              entityId: notification.entity.entityId,
              entityType: notification.entity.entityType,
            })

            if (!subscription.muted) {
              this.$notice.update({
                id: `${notification.subscriptionEntityId}_${notification.message.eventType}`,
                type: 'info',
                title: `${this.$t(`Notifications.NotificationType.${notification.message.messageType}`)}`,
                message: message,
                dangerouslyUseHTMLString: true,
                duration: 10,
              })
            }

          })
        })
      })
    }
  },
  computed: {
    ...mapGetters('notification', ['notifications', 'accessNotification', 'loadingNotifications']),
    ...mapGetters({
      stateLoading: 'getStateLoading',
    }),
    showModalNotification() {
      return !!this.modalNotification
    },
    isNewNotification() {
      if (!this.sortNotifications?.length) {
        return false
      }
      return !![].concat.apply([], this.sortNotifications.map(i => i.message)).find(i => !i.viewed)
    },
    sortNotifications() {
      if (!this.notifications?.length) {
        return []
      }
      return this.$_.cloneDeep(this.notifications)
        .sort((a, b) => b.message.date.getTime() - a.message.date.getTime())
        .slice(0,20)
    }
  },
  async beforeDestroy() {
    if (this.accessNotification) {
      this.$root.$off('newNotification', this.addNewNotifications)
    }
  },
  mounted() {
    if (this.accessNotification) {
      if (!this.stateLoading.status) {
        this.$store.dispatch('setTenderStatuses')
      }
      this.$root.$on('newNotification', this.addNewNotifications)
    }
  },
  components: {
    NotificationCard,
    InnerChatMessage
  },
}
</script>
<style scoped lang="scss">
::v-deep .modal-notification {
    padding: 10px 0 0 0;
    ::v-deep .modal-body {
      background: blue;
      padding-top: 5px;
      border-top: 2px solid var(--color-main-green);
    }
    &::v-deep .modal-body {
      background: red;
      padding-top: 5px;
      border-top: 2px solid var(--color-main-green);
    }
    &::v-deep.modal-body {
      background: green;
      padding-top: 5px;
      border-top: 2px solid var(--color-main-green);
    }
    &::v-deep > .modal-body {
      background: yellow;
      padding-top: 5px;
      border-top: 2px solid var(--color-main-green);
    }
}
.notification-body {
  border: 2px solid var(--color-main-green);
  background: var(--v-main__light_green-base);
  min-width: 335px;
  border-radius: 4px;
  max-height: calc(100vh - 80px);
  &_cards {
    max-width: 331px;
    max-height: 315px;
    overflow-y: scroll;
    padding: 0 0 0 10px;
  }
}
.notification-gotoAll {
  text-align: center;
  font-weight: 600;
  padding: 5px 20px 5px 20px;
  font-size: 14px;
  line-height: 20px;
}
</style>
